import { render, staticRenderFns } from "./ApplicantPersonalPhoneData.vue?vue&type=template&id=c3030346&"
import script from "./ApplicantPersonalPhoneData.vue?vue&type=script&lang=js&"
export * from "./ApplicantPersonalPhoneData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports